// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-dash-modal__rules[data-v-356a5529] {\n  font-weight: var(--ds-font-weight-regular);\n  font-size: var(--ds-font-size-sm);\n  color: var(--ds-color-text-2);\n}\n.v-input[data-v-356a5529] {\n  padding: 0;\n  margin-top: var(--ds-spacing-stack-nano);\n}", ""]);
// Exports
module.exports = exports;
